import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandsMask',
})
export class ThousandsMaskPipe implements PipeTransform {
  transform(value: number | string): string {
    if (Number.isNaN(value)) {
      return value.toString();
    }

    if (value === null || value === undefined) {
      return '';
    }

    const num = typeof value === 'string' ? parseFloat(value) : value;
    return num.toLocaleString('pt-BR');
  }
}
